<button *ngIf="!isLink" [className]="className">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>

<a
  *ngIf="isLink"
  [href]="url"
  target="_blank"
  rel="noopener noreferrer"
  [className]="className"
  [attr.aria-label]="ariaLabel"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<ng-template #content>
  <app-icon [name]="iconType" class="social-button__icon"></app-icon>
  <span class="social-button__name" *ngIf="name">{{ name }}</span>
</ng-template>
